import * as React from 'react';
import { DesignSystemHtmlElement } from '../../lib/constants/constants';

declare global {
  namespace React.JSX {
    interface IntrinsicElements {
      'sagov-loading-spinner': DesignSystemHtmlElement;
    }
  }
}

/**
 * Component to show when an unrecoverable error occurs on a pilet.
 *
 * @param {string} errorLabel The message to show on the error.
 * @returns {React.JSX.Element}
 */
export function ComponentLoadSpinner(): React.JSX.Element {
  return <sagov-loading-spinner role="progressbar"></sagov-loading-spinner>;
}
